module.exports = __webpack_public_path__ + "img/emoji_yukuai.94c51b98.png";